import { ref } from "vue";

export default function(startVal: any, validators: any) {
  const input = ref(startVal);
  const errors = ref([]);
  errors.value = validators.map((validator: any) => {
    return validator(startVal);
  });
  return {
    input,
    errors
  };
}
